import { LocalStorage } from 'quasar';

export function bootComplete(state) {
  state.isBooting = false;
}

export function blockInteraction(state) {
  state.canInteract = false;
}

export function allowInteraction(state) {
  state.canInteract = true;
}

export function setValidPin(state) {
  state.validPin = true;
  LocalStorage.set('pin', true);
}

export function setInvalidPin(state) {
  state.validPin = false;
  LocalStorage.remove('pin');
}

export function setValidAge(state) {
  state.validAge = true;
}

export function setResetPinDialog(state) {
  state.resetDialog = true;
}

export function clearResetPinDialog(state) {
  state.resetDialog = false;
}

export function setNotification(state, {
  icon,
  title,
  heading,
  message,
}) {
  state.notification = {
    icon,
    title,
    heading,
    message,
  };
}

export function clearNotification(state) {
  state.notification = null;
}

export function updateLanguage(state, { language }) {
  state.language = language;
  LocalStorage.set('language', language);
}

export function flush(state) {
  state.notification = false;
  state.resetDialog = false;
  state.validPin = false;
  state.validAge = false;
  state.language = 'is';
  LocalStorage.clear();
  this.$router.replace('/pin');
}
